<script>
    /*
       Button:
       <Button label="woah" on:click={() => {}} bg="red"/>
    */
    import { createEventDispatcher } from 'svelte';
    import '../colors.css';

    export let label = "";
    export let bg = "green";

    const dispatch = createEventDispatcher();

    let bgClass = "bg-brand-green";

    const handleClick = () => {
        dispatch('click');
    }

    $: switch (bg) {
        case "red":
            bgClass = "bg-brand-red";
            break;

        case "blue":
            bgClass = "bg-brand-blue";
            break;

        case "yellow":
            bgClass = "bg-brand-yellow";
            break;

        default:
            break;
    }
    
</script>

<button
    class={bgClass}
    on:click={handleClick}>
  {label}
</button>

<style>
    button {
        -webkit-appearance: button;
        padding-left: 1rem;
        padding-right: 1rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        border-radius: 0.25rem;
        border: none;
        text-transform: none;
        font-weight: 700;
        box-shadow: none;
        color: white;
    }
    button:focus, button:hover {
        opacity: 0.5;
        transition: opacity 0.15s ease-in;
    }
</style>
